import Style from "ol/style/Style";
import Circle from "ol/style/Circle";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import Text from "ol/style/Text";

export default function(size){

    return new Style({
        image: new Circle({
            radius: 10,
            stroke: new Stroke({
                color: '#ffffff'
            }),
            fill: new Fill({
                color: '#333333'
            })
        }),
        text: new Text({
            text: size.toString(),
            fill: new Fill({
                color: '#ffffff'
            })
        })
    });
}
